import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import {
  GetPermitTypesByOrganizationId,
  GetPermitTypesByOrganizationIdVariables,
} from "./__generated__/GetPermitTypesByOrganizationId";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";

export const GET_PERMIT_TYPES_BY_ORGANIZATION_ID = gql`
  ${PERMIT_TEMPLATE_FIELDS}
  query GetPermitTypesByOrganizationId($organizationId: String!) {
    permitTypesByOrganizationId(organizationId: $organizationId) {
      id
      name
      blueprintKey
      template {
        ...PermitTemplateFields
      }
    }
  }
`;

export function useLazyGetPermitTypesByOrganizationId() {
  const [getPermitTypesByOrganizationId, { loading, error, data }] = useLazyQuery<
    GetPermitTypesByOrganizationId,
    GetPermitTypesByOrganizationIdVariables
  >(GET_PERMIT_TYPES_BY_ORGANIZATION_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getPermitTypesByOrganizationId,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
